import { useState } from 'react';
import { Download, Share, X } from 'lucide-react';
import { useTranslation } from '../../i18n/useTranslation';
import { useInstallPrompt } from '../../hooks/useInstallPrompt';

export function InstallButton() {
  const { t } = useTranslation();
  const { platform, isInstalled, install } = useInstallPrompt();
  const [showInstructions, setShowInstructions] = useState(false);

  if (isInstalled) return null;

  const handleClick = async () => {
    if (platform === 'native') {
      const installed = await install();
      if (!installed) {
        setShowInstructions(true);
      }
    } else {
      setShowInstructions(true);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        className="flex items-center gap-1.5 px-3 py-2 text-sm text-neutral-700 hover:text-primary-600 rounded-md transition-colors min-h-[44px]"
        aria-label={t('App.PWA.InstallButton.AriaLabel')}
      >
        <Download className="w-4 h-4" />
        <span className="hidden sm:inline">{t('App.PWA.InstallButton.Label')}</span>
      </button>

      {showInstructions && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[2100] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold">
                {t('App.PWA.InstallPrompt.Title')}
              </h3>
              <button
                onClick={() => setShowInstructions(false)}
                className="p-2 hover:bg-neutral-100 rounded-full min-h-[44px] min-w-[44px] flex items-center justify-center"
              >
                <X className="w-5 h-5 text-neutral-500" />
              </button>
            </div>

            {platform === 'ios' ? (
              <p className="text-sm text-neutral-600">
                {t('App.PWA.InstallPrompt.IosTapShare')}{' '}
                <Share className="inline w-4 h-4 -mt-0.5 text-primary-600" />{' '}
                {t('App.PWA.InstallPrompt.IosThen')}{' '}
                <strong>{t('App.PWA.InstallPrompt.IosAddToHomeScreen')}</strong>
              </p>
            ) : platform === 'macos-safari' ? (
              <p className="text-sm text-neutral-600">
                {t('App.PWA.InstallPrompt.MacSafariInstructions')}
              </p>
            ) : (
              <p className="text-sm text-neutral-600">
                {t('App.PWA.InstallButton.ChromeInstructions')}
              </p>
            )}

            <button
              onClick={() => setShowInstructions(false)}
              className="mt-4 w-full px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 text-sm font-medium min-h-[44px]"
            >
              {t('App.Common.Close')}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
